package domain.player

import kotlinx.serialization.Serializable

/**
 * Persisted graphics preferences, separate from player handling config.
 *
 * @param boardShake        Intensity of board shake animations. 0.0 = off, 1.0 = full.
 *                          Hard drops use this value directly; line clears use 0.4× of it.
 * @param backgroundOpacity Opacity of the animated background. 0.0 = off, 1.0 = full.
 */
@Serializable
data class GraphicsConfig(
    val boardShake: Double = 0.6,
    val backgroundOpacity: Double = 1.0,  // 0.0 = off, 1.0 = full
)

/**
 * Thin compatibility shim over [PlayerSession].
 * Existing call sites need no changes.
 */
object GraphicsConfigStore {

    fun save(config: GraphicsConfig) {
        PlayerSession.updateGraphics(config)
    }

    fun load(): GraphicsConfig = PlayerSession.graphics

    fun reset(): GraphicsConfig {
        val defaults = GraphicsConfig()
        PlayerSession.updateGraphics(defaults)
        return defaults
    }
}
